import MessageService from "app/services/messageService";
import React, { useEffect, useState } from "react";
import MessagesListItem from "./MessagesListItem";

export interface LabelProps {
  className?: string;
  children?: React.ReactNode;
}

export interface MessgaeList {
  id: number;
  created: string;
  username: string;
  message: string;
}

const MessagesList = () => {
  const [messagesList, setMessagesList] = useState<MessgaeList[]>([]);
  useEffect(() => {
    MessageService.getMessagesList().then((data) => {
      console.log(data);
      setMessagesList(data);
    });
    console.log(messagesList);
  }, []);
  return (
    <div className="flex flex-col mt-8 ">
      <div className=" md:block hidden  flex flex-row items-center justify-between text-xs">
        <span className="font-bold">Conversations</span>
      </div>

      {messagesList.map((m, i) => {
        return (
          <MessagesListItem
            key={i}
            created={m.created}
            message={m.message}
            username={m.username}
          />
        );
      })}
    </div>
  );
};

export default MessagesList;
